import { motion } from 'framer-motion';

import { AnimationShell } from '@/components';
import { cn } from '@/utils/styles';

const animationCollapseVariants = {
  open: {
    opacity: 1,
    height: 'auto',
  },
  closed: {
    opacity: 0,
    height: 0,
  },
};

export type CollapsableProps = {
  readonly header: React.ReactNode;
  readonly children: React.ReactNode;
  readonly index?: number;
  readonly isExpanded?: boolean;
};

export function Collapsable({ index = 0, isExpanded = false, header, children }: CollapsableProps) {
  return (
    <AnimationShell
      element="article"
      type="opacity"
      duration={0.15 * index}
      className={cn('bg-base-white h-auto w-full overflow-hidden rounded-lg border border-neutral-50 shadow-xs')}
    >
      {header}

      <motion.div
        variants={animationCollapseVariants}
        initial="closed"
        animate={isExpanded ? 'open' : 'closed'}
        transition={{ duration: 0.15 }}
        className="min-w-0 overflow-hidden"
      >
        {children}
      </motion.div>
    </AnimationShell>
  );
}
